export const DISPLAY_NAME_VARIABLE = '@displayedName;';

export const processTemplate = (template: string, displayedName: string) => {
  const reg = new RegExp(DISPLAY_NAME_VARIABLE, 'g');
  return template.replace(reg, displayedName);
};
